import Signature from "@store/v1/modules/signature"

const modulesFiles = require.context("./modules", false, /\.js$/);

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
    modules[moduleName] = modulesFiles(modulePath).default;
    return modules;
}, {});

export default {
    namespaced: true,
    modules: {
        ...modules,
        signature: Signature
    }
}
